import axios from "axios";
import { ENDPOINT } from "../constants";
import { piopiy,logoutPiopiy } from "../utils/piopiy";

const getAccessToken = () => localStorage.getItem("token");
const setAccessToken = token => localStorage.setItem("token", token);

//and interceptor comes here
const accessToken = getAccessToken();
const platformApi = axios.create({
  baseURL: ENDPOINT,
  headers: {
    "content-Type": "application/json"
  }
});
platformApi.interceptors.request.use(config => {
  const token = getAccessToken();
  if (token) {
    config.headers["x-access-token"] = token;
  }
  return config;
});
platformApi.interceptors.response.use(
  config => config,
  async error => {
    if (error.response && error.response.status === 401) {

      console.warn("Token expired or invalid. Logging out.");

      const selectedTelecmiUserId = localStorage.getItem('selectedTelecmiUserId');

      if (selectedTelecmiUserId) {
        try {
          await platformApi.post(`/api/telecmi/teleUser/toggleStatus/${selectedTelecmiUserId}`, {});
        } catch (toggleErr) {
          console.error("Failed to toggle TeleCMI user status:", toggleErr);
        }
      }

      localStorage.removeItem("token");  
      localStorage.removeItem("branch");
      localStorage.removeItem('selectedTelecmiUserId');
      logoutPiopiy();
      // piopiy.logout();
      window.location.href = "/";       
    }
    return Promise.reject(error);
  }
);
export { platformApi, setAccessToken, ENDPOINT as baseUrl, getAccessToken };
